import { useEffect, useState } from 'react'

const useImageError = () => {
  const [elementRef, setElementRef] = useState(null)
  const [error, setError] = useState(false)

  const handleError = () => {
    setError(true)
  }

  const retry = () => {
    setError(false)
  }

  useEffect(() => {
    if (elementRef) {
      elementRef.addEventListener('error', handleError)
    }

    return () => {
      if (elementRef) {
        elementRef.removeEventListener('error', handleError)
      }
    }
  }, [elementRef])

  return {
    elementRef,
    error,
    retry,
    setElementRef,
  }
}

export default useImageError
